import React from 'react';

export const FallbackIcon = ({ name }: { name: string }) => (
  <div className="relative z-20 flex h-[34px] w-[34px] items-center justify-center rounded-[100%] bg-base-gray p-4 text-center text-display-xs font-medium text-white">
    <h1 className="absolute top-[50%] -translate-y-1/2">{name?.substring(0, 1).toUpperCase()}</h1>
  </div>
);
